<template>
  <div>
    <InvoiceActionsMenu
      :invoice="invoice"
      :visible-action-keys="visibleActionKeys"
      :tippy-options="tippyOptions"
      hide-membership-savings-toggle
    >
    </InvoiceActionsMenu>
  </div>
</template>

<script>
import InvoiceActionsMenu from "@/Invoice/InvoiceActionsMenu.vue";
import { EventBus } from "~/lib/event_bus";

export default {
  components: {
    InvoiceActionsMenu
  },
  props: {
    invoice: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      tippyOptions: {
        theme: "light revenue-context-menu tooltip-standard-size"
      },
      visibleActionKeys: ["cancel", "resubmit_for_payment"]
    };
  },
  mounted() {
    EventBus.$on("invoice-cancelled", this.refreshDatatable);
    EventBus.$on("invoice-resubmitted", this.refreshDatatable);
  },
  beforeUnmount() {
    EventBus.$off("invoice-cancelled", this.refreshDatatable);
    EventBus.$off("invoice-resubmitted", this.refreshDatatable);
  },
  methods: {
    refreshDatatable() {
      EventBus.$emit("refresh-datatable");
    }
  }
};
</script>

<style lang="scss">
.tippy-tooltip.revenue-context-menu-theme {
  .tippy-content {
    background-color: var(--white) !important;
  }
}
</style>
